import {
  __,
  allPass,
  curry,
  gte,
  lensProp,
  lt,
  pipe,
  prepend,
  view,
} from "ramda";
import * as editMediaReducer from "edit-media/redux/editMediaReducer";

const emptyAutocompleteItem = {
  id: "",
  displayName: "",
};

// reducers
const getEditMedia = view(lensProp("editMedia"));

export const getCategories = pipe(
  getEditMedia,
  editMediaReducer.getCategories,
  prepend(emptyAutocompleteItem),
);

export const getContributorTypes = pipe(
  getEditMedia,
  editMediaReducer.getContributorTypes,
);

export const getContributor = curry((index, state) =>
  pipe(getEditMedia, editMediaReducer.getMediaItemContributor(index))(state),
);

export const getContributorDialogDisableSave = pipe(
  getEditMedia,
  editMediaReducer.getContributorDialogDisableSave,
);

export const getContributorDialogErrors = pipe(
  getEditMedia,
  editMediaReducer.getContributorDialogErrors,
);

export const getContributorDialogFields = pipe(
  getEditMedia,
  editMediaReducer.getContributorDialogFields,
);

export const getAddContributorDialogVisible = pipe(
  getEditMedia,
  allPass([
    pipe(editMediaReducer.getContributorDialogIndex, lt(__, 0)),
    editMediaReducer.getContributorDialogVisible,
  ]),
);

export const getEditContributorDialogVisible = pipe(
  getEditMedia,
  allPass([
    pipe(editMediaReducer.getContributorDialogIndex, gte(__, 0)),
    editMediaReducer.getContributorDialogVisible,
  ]),
);

export const getContributorRoles = pipe(
  getEditMedia,
  editMediaReducer.getContributorRoles,
);

export const getEditMediaActiveTabIndex = pipe(
  getEditMedia,
  editMediaReducer.getActiveTabIndex,
);

export const getEditMediaDisableSave = pipe(
  getEditMedia,
  editMediaReducer.getDisableSave,
);

export const getEditMediaErrors = pipe(
  getEditMedia,
  editMediaReducer.getErrors,
);

export const getEditMediaItem = pipe(
  getEditMedia,
  editMediaReducer.getMediaItem,
);

export const getEditMediaItemDescription = pipe(
  getEditMediaItem,
  view(lensProp("description")),
);

export const getEditMediaItemDescriptionText = pipe(
  getEditMediaItem,
  view(lensProp("descriptionText")),
);

export const getEditMediaItemType = pipe(
  getEditMediaItem,
  view(lensProp("type")),
);

export const getEditMediaItemContributors = pipe(
  getEditMedia,
  editMediaReducer.getMediaItemContributors,
);

export const getEditMediaLoading = pipe(
  getEditMedia,
  editMediaReducer.getLoading,
);

export const getEditMediaOriginalMediaItem = pipe(
  getEditMedia,
  editMediaReducer.getOriginalMediaItem,
);

export const getEditMediaVisible = pipe(
  getEditMedia,
  editMediaReducer.getVisible,
);

export const getLanguages = pipe(getEditMedia, editMediaReducer.getLanguages);

export const getLicenseTypes = pipe(
  getEditMedia,
  editMediaReducer.getLicenseTypes,
);

export const getRemoveContributorDialogIndex = pipe(
  getEditMedia,
  editMediaReducer.getRemoveContributorDialogIndex,
);

export const getRemoveContributorDialogVisible = pipe(
  getEditMedia,
  editMediaReducer.getRemoveContributorDialogVisible,
);

export const getEditThumbnailDialogVisible = pipe(
  getEditMedia,
  editMediaReducer.getThumbnailDialogVisible,
);

export const getThumbnailDialogFile = pipe(
  getEditMedia,
  editMediaReducer.getThumbnailFile,
);

export const getThumbnailDialogProcessing = pipe(
  getEditMedia,
  editMediaReducer.getThumbnailProcessing,
);
